import {EsquireClient} from "@/types/clients/esquire";

export default class GetPaymentMethods {
  constructor(private client: EsquireClient) {}

  public async send() {

    const url = await this.client.fetchUrlFromSession("payment-methods");

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "GET"
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to get payment methods");
    }

    return await response.json();
  }
}
